// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"gg","summaryPar":"hg","ratingCategories":"ig","reviewerInfo":"jg","reviewTypes":"kg","expanded":"lg"};